function Settings(dimensions) {

  const margin = ({top: 100, right: dimensions[0]/3, bottom: 100, left: 120});

  // settings
  let settingsDict = {
    width:dimensions[0],
    height:dimensions[1],
    margin:margin,
    innerWidth:dimensions[0] - margin.left - margin.right,
    innerHeight:dimensions[1] - margin.top - margin.bottom,
  }

  return settingsDict;
}

export default Settings;
